import { operationTaskSchema } from "./IOperationTask";
import { z } from "zod";
import { teamsPowerShellTaskSchema } from "./ITeamsPowerShellTask";

export const operationRequestBaseSchema = z.object({
    tasks: z.array(z.union([operationTaskSchema, teamsPowerShellTaskSchema]))
});

export type IOperationRequestBase = z.infer<typeof operationRequestBaseSchema>;